module.exports = __webpack_public_path__ + "export-template.svg?67dcd84922a755ebe358cdc3310b4637";